import request from 'sb-request'
import { getGqlQuery } from 'common/helpers'


const createUserInterview = (body) =>
  request.post('graphql?createUserInterview', {
    body: {
      query: `
        mutation {
          ${getGqlQuery('createUserInterview', { input: body })} {
            result
          }
        }
      `,
    },
  })


export default {
  createUserInterview,
}
